import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useAppData } from '../../context/AppContext';

export default function MoveInstrumentModal({ instrument, currentWatchlistId, onClose }) {
  const { watchlists, moveInstrument } = useAppData();
  const [targetId, setTargetId] = useState('');
  const [loading, setLoading] = useState(false);

  const availableWatchlists = watchlists.filter(w => w.id !== currentWatchlistId);

  const handleMove = async () => {
    if (!targetId) return;
    setLoading(true);
    const success = await moveInstrument(instrument, currentWatchlistId, targetId);
    if (success) onClose();
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[70] p-4 backdrop-blur-sm">
      <div className="bg-app-surface border border-app-border rounded-xl w-full max-w-sm shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-app-border flex justify-between items-center">
          <h2 className="text-lg font-bold flex items-center gap-2 text-white uppercase tracking-tighter">
            <SafeIcon icon={FiIcons.FiShare} className="text-app-accent" /> Move Security
          </h2>
          <button onClick={onClose} className="text-app-muted hover:text-white transition-colors">
            <FiIcons.FiX size={24} />
          </button>
        </div>
        
        <div className="p-6 space-y-6">
          <div className="bg-app-bg/50 p-4 rounded-lg border border-app-border">
            <p className="text-[10px] font-black uppercase tracking-widest text-app-muted mb-1">Moving Instrument</p>
            <p className="text-xl font-mono font-black text-app-accent">{instrument.code}</p>
            <p className="text-xs text-app-text opacity-60 mt-0.5">{instrument.name}</p>
          </div>

          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">Select Target Watchlist</label>
            <select 
              value={targetId} 
              onChange={e => setTargetId(e.target.value)}
              className="w-full bg-app-bg border-app-border text-sm font-bold uppercase tracking-wider h-12"
            >
              <option value="">Choose Destination...</option>
              {availableWatchlists.map(w => (
                <option key={w.id} value={w.id}>{w.name}</option>
              ))}
            </select>
            {availableWatchlists.length === 0 && (
              <p className="text-[10px] text-app-red uppercase font-black tracking-tighter mt-2">
                Create another watchlist first to move assets.
              </p>
            )}
          </div>

          <div className="flex gap-3 pt-2">
            <button 
              onClick={onClose} 
              className="flex-1 py-3 text-xs font-black uppercase tracking-widest border border-app-border rounded-lg hover:bg-white/5 transition-colors"
            >
              Cancel
            </button>
            <button 
              onClick={handleMove}
              disabled={!targetId || loading}
              className="flex-1 py-3 text-xs font-black uppercase tracking-widest bg-app-accent text-black rounded-lg hover:bg-yellow-500 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? <FiIcons.FiLoader className="animate-spin" /> : <FiIcons.FiArrowRight />}
              Transfer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}